module.exports = __webpack_public_path__ + "assets/images/icons/icon_vaccine-green.svg?v=745f921a";